import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for UsageControlvalues
export const UsageControlvalues = createSlice({
  name: "UsageControlvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    UsageControlvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_UsageControlvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_UsageControlvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    UsageControlvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_UsageControlvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchUsageControlvalues:(state)=>{
        state.switch = false
    }
  },
});
export default UsageControlvalues.reducer;
export const {
  UsageControlvalues_datagrid,
  success_api_call_UsageControlvalues_datagrid,
  failure_api_call_UsageControlvalues_datagrid,
  create_UsageControlvalues_datagrid_complete_api,
  UsageControlvalues_datagrid_is_success,false_switchUsageControlvalues
} = UsageControlvalues.actions;
